import { AppLayout } from "@/components/layout/AppLayout";
import Maintenance from "@/pages/Maintenance";
import { useMaintenance } from "@/hooks/useMaintenance";
import { Logo } from "@/components/common/Logo";
import { Loader2 } from "lucide-react";

const Splash = () => (
  <div className="paper-bg flex min-h-screen flex-col items-center justify-center gap-4 text-halalgo-ink" data-testid="public-splash">
    <Logo withLink={false} size="lg" />
    <Loader2 className="h-5 w-5 animate-spin text-halalgo-green-600" />
  </div>
);

// Wraps the entire public marketing experience. When maintenance mode is ON it
// replaces every public route with the branded maintenance page. Admin routes
// live outside this layout, so admins are never affected.
export const PublicLayout = () => {
  const { status, loading, refresh } = useMaintenance();

  // Only block rendering on the very first load when we have no cached value.
  if (loading && !status) return <Splash />;

  if (status?.maintenance_mode) {
    return <Maintenance status={status} onRefresh={refresh} refreshing={loading} />;
  }

  return <AppLayout />;
};
